import { HelpArticle } from "../../hooks/useHelpPanel";

export const helpArticlePaths: Record<HelpArticle, string> = {
    [HelpArticle.DESIGNS_OVERVIEW]: "/help/designs-overview.md",
    [HelpArticle.PATTERN_DETAILS]: "/help/pattern-details.md",
    [HelpArticle.PATTERN_TYPES]: "/help/pattern-details/pattern-types.md",
    // No *_DETAILED counterpart on purpose — the single article covers both depths.
    [HelpArticle.MURAL_LIMITATIONS]: "/help/pattern-details/mural-limitations.md",
    [HelpArticle.TECHNICAL_SPECS]: "/help/pattern-details/technical-specs.md",
    [HelpArticle.DEFAULT_SCALES]: "/help/pattern-details/default-scales.md",
    [HelpArticle.REVIEW_AND_NAME]: "/help/pattern-details/review-and-name.md",
    [HelpArticle.COLORS_AND_STYLE]: "/help/pattern-details/colors-and-style.md",
    [HelpArticle.PRODUCT_SETUP]: "/help/pattern-details/product-setup.md",
    [HelpArticle.WALLPAPER_SCALE]: "/help/pattern-details/product-setup/wallpaper-scale.md",
    [HelpArticle.WRAPPING_PAPER_SCALE]: "/help/pattern-details/product-setup/wrapping-paper-scale.md",
    [HelpArticle.COLLECTIONS]: "/help/pattern-details/product-setup/collections.md",
    [HelpArticle.PHOTO_GENERATION]: "/help/pattern-details/photo-generation.md",
    [HelpArticle.SAMPLE_PHOTOS]: "/help/pattern-details/photo-generation/samples.md",
    [HelpArticle.MOCKUP_PHOTOS]: "/help/pattern-details/photo-generation/mockups.md",
    [HelpArticle.LISTING_SETUP]: "/help/pattern-details/listing-setup.md",
    [HelpArticle.PRICING]: "/help/pattern-details/listing-setup/pricing.md",
    [HelpArticle.LISTING_IMAGES]: "/help/pattern-details/listing-setup/listing-images.md",
    [HelpArticle.RELEASE]: "/help/pattern-details/listing-setup/release.md",
    [HelpArticle.DESIGNS_OVERVIEW_DETAILED]: "/help/detailed/designs-overview.md",
    [HelpArticle.PATTERN_DETAILS_DETAILED]: "/help/detailed/pattern-details.md",
    [HelpArticle.PATTERN_TYPES_DETAILED]: "/help/detailed/pattern-details/pattern-types.md",
    [HelpArticle.TECHNICAL_SPECS_DETAILED]: "/help/detailed/pattern-details/technical-specs.md",
    [HelpArticle.DEFAULT_SCALES_DETAILED]: "/help/detailed/pattern-details/default-scales.md",
    [HelpArticle.REVIEW_AND_NAME_DETAILED]: "/help/detailed/pattern-details/review-and-name.md",
    [HelpArticle.COLORS_AND_STYLE_DETAILED]: "/help/detailed/pattern-details/colors-and-style.md",
    [HelpArticle.PRODUCT_SETUP_DETAILED]: "/help/detailed/pattern-details/product-setup.md",
    [HelpArticle.WALLPAPER_SCALE_DETAILED]: "/help/detailed/pattern-details/product-setup/wallpaper-scale.md",
    [HelpArticle.WRAPPING_PAPER_SCALE_DETAILED]: "/help/detailed/pattern-details/product-setup/wrapping-paper-scale.md",
    [HelpArticle.COLLECTIONS_DETAILED]: "/help/detailed/pattern-details/product-setup/collections.md",
    [HelpArticle.PHOTO_GENERATION_DETAILED]: "/help/detailed/pattern-details/photo-generation.md",
    [HelpArticle.SAMPLE_PHOTOS_DETAILED]: "/help/detailed/pattern-details/photo-generation/samples.md",
    [HelpArticle.MOCKUP_PHOTOS_DETAILED]: "/help/detailed/pattern-details/photo-generation/mockups.md",
    [HelpArticle.LISTING_SETUP_DETAILED]: "/help/detailed/pattern-details/listing-setup.md",
    [HelpArticle.PRICING_DETAILED]: "/help/detailed/pattern-details/listing-setup/pricing.md",
    [HelpArticle.LISTING_IMAGES_DETAILED]: "/help/detailed/pattern-details/listing-setup/listing-images.md",
    [HelpArticle.RELEASE_DETAILED]: "/help/detailed/pattern-details/listing-setup/release.md",
    [HelpArticle.API_ORDERS]: "/help/api-orders.md",
    [HelpArticle.API_SAMPLE_SPEC]: "/help/api-sample-spec.md",
    [HelpArticle.MATERIALS_OVERVIEW]: "/help/materials/overview.md",
    [HelpArticle.MATERIAL_PEEL_AND_STICK]: "/help/materials/peel-and-stick.md",
    [HelpArticle.MATERIAL_LUXE_TRADITIONAL]: "/help/materials/luxe-traditional.md",
    [HelpArticle.MATERIAL_LUXE_PEEL_AND_STICK]: "/help/materials/luxe-peel-and-stick.md",
    [HelpArticle.SHOPIFY_PLUGIN]: "/help/shopify-plugin.md",
    [HelpArticle.SHIPPING_RATES]: "/help/shipping-rates.md",
};
